import { Button } from "antd";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  ChangeWebsiteItemGlobalData,
  ChangeWebsitesStateGlobalData,
  EditCustomStyles,
  GetCurrentStoreData,
  SavePartialWebsiteData,
  SaveWebsiteBackup,
  WebsitesState,
} from "../../store/websites/types";
import {
  getCurrentStoreData,
  savePartialWebsiteData,
  saveToLocalBackup,
  saveWebsiteBackup,
} from "../../store/websites/thunks";
import {
  changeWebsiteItemGlobalData,
  changeWebsitesStateGlobalData,
  editCustomStyles,
} from "../../store/websites/actions";
import { updateWebsiteAsync } from "../../helpers/async/updateWebsiteAsync";
import _ from "lodash";
import { AuthState } from "../../store/auth/types";

interface Props {
  websites: WebsitesState;
  auth: AuthState;
  getCurrentStoreData: GetCurrentStoreData;
  changeWebsitesStateGlobalData: ChangeWebsitesStateGlobalData;
  savePartialWebsiteData: SavePartialWebsiteData;
  changeWebsiteItemGlobalData: ChangeWebsiteItemGlobalData;
  editCustomStyles: EditCustomStyles;
  saveWebsiteBackup: SaveWebsiteBackup;
  saveToLocalBackup: any;
}

const Name = (props: Props): JSX.Element => {
  const {
    websites,
    auth,
    getCurrentStoreData,
    changeWebsitesStateGlobalData,
    savePartialWebsiteData,
    changeWebsiteItemGlobalData,
    editCustomStyles,
    saveWebsiteBackup,
    saveToLocalBackup
  } = props;

  const { currentWebsite } = getCurrentStoreData();

  const getFullStylesObject = (stylesObj) => {
    const keys = [
      "buttonRadius",
      "buttonBorderColor",
      "borderSize",
      "buttonHorizontalPadding",
      "buttonVerticalPadding",
      "fontSizeParagraphs",
      "fontSizeH1",
      "fontSizeH2",
      "fontSizeH3",
      "inputRadius",
      "inputBorderSize",
      "inputVerticalPadding",
      "inputHorizontalPadding",
      "buttonFontSize",
      "inputFontSize",
      "buttonFontWeight",
      "inputFontWeight",
      "buttonShadow",
      "fontSizeH3",
      "inputLabelFontSize",
      "inputLabelFontWeight",
      "searchRadius",
      "searchBorderSize",
      "searchHorizontalPadding",
      "searchVerticalPadding",
      "searchFontSize",
      "searchFontWeight",
      "cardRadius",
      "cardShadow",
      "fontSizeContent",
      "additionalVerticalSpace",
      "inputLabelMarginBottom",
      "customCss",
    ];
    const res = {};
    keys.forEach((key) => {
      res[key] = _.get(stylesObj, key, null);
    });
    return res;
  };

  const initialCustomStylesRef = useRef(
    getFullStylesObject(_.get(currentWebsite, "custom_styles", {}))
  );

  const saveChanges = async () => {
    changeWebsitesStateGlobalData({
      isCustomStylesWaitingForServer: true,
    });
    try {
      saveWebsiteBackup("website");
    } catch(e) {
      console.error(_.get(e, "response.data"));
    }
    const custom_styles = _.get(currentWebsite, "custom_styles", {});
    updateWebsiteAsync({
      accessToken: auth.accessToken,
      subdomain: currentWebsite.subdomain,
      data: { custom_styles },
    })
      .then(() => {
        initialCustomStylesRef.current = getFullStylesObject(
          custom_styles
        );
        saveToLocalBackup("website");
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
      })
      .finally(() => {
        changeWebsiteItemGlobalData({
          websiteId: currentWebsite.id,
          data: {
            hasUnsavedChanges: false,
          },
        });
        changeWebsitesStateGlobalData({
          isCustomStylesWaitingForServer: false,
        });
      });
  };

  const resetStyles = () => {
    editCustomStyles({
      websiteId: currentWebsite.id,
      newData: initialCustomStylesRef.current,
    });
    changeWebsiteItemGlobalData({
      websiteId: currentWebsite.id,
      data: {
        hasUnsavedChanges: false,
      },
    });
  };

  useEffect(() => {
    return () => {
      const { currentWebsite } = getCurrentStoreData();
      if (!currentWebsite) return null;
      if (
        currentWebsite.hasUnsavedChanges &&
        !websites.isCustomStylesWaitingForServer
      ) {
        resetStyles();
      }
    };
  }, []);

  if (!currentWebsite.hasUnsavedChanges) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "#FAFAFA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        zIndex: 1200,
        borderTop: "1px solid #E8E8E8",
        position: "fixed",
        bottom: 0,
        width: 209,
        padding: 8,
        left: 56,
        boxShadow: `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.03) 0px -4px 6px -1px, rgba(0, 0, 0, 0.03) 0px -2px 4px -2px`
      }}
    >
      <Button
        type="primary"
        onClick={saveChanges}
        loading={websites.isCustomStylesWaitingForServer}
        className="editor__cta-button-new"
        style={{
          height: 30
        }}
      >
        Save
      </Button>
      <Button
        disabled={websites.isCustomStylesWaitingForServer}
        onClick={resetStyles}
        className="editor__cta-button-new"
        style={{
          height: 30
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  websites: state.websites,
  auth: state.auth,
});
export default connect(mapStateToProps, {
  getCurrentStoreData,
  changeWebsitesStateGlobalData,
  savePartialWebsiteData,
  changeWebsiteItemGlobalData,
  editCustomStyles,
  saveWebsiteBackup,
  saveToLocalBackup,
})(Name);
